import { useGlobalPluginStore } from '../store';

export function usePluginLogs(plugin?: string) {
  return useGlobalPluginStore((state) =>
    plugin ? state.logs.filter((l) => l.plugin === plugin) : state.logs
  );
}

export function clearLogs() {
  const { clearLogs } = useGlobalPluginStore.getState();
  return clearLogs();
}
